import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Pencil, Check, X } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const R = (n) => new Intl.NumberFormat('en-ZA', { style: 'currency', currency: 'ZAR' }).format(n || 0);

export const CollectiveRevenue = ({ transport, headers, onChanged }) => {
  const c = transport?.drivers_collective || {};
  const [editRate, setEditRate] = useState(false);
  const [rate, setRate] = useState('');
  const gap = (c.value || 0) - (transport?.captured_revenue || 0);

  const toggle = async () => {
    try {
      await axios.put(`${API_URL}/api/group-overview/collective-setting`, { use_collective: !transport.use_collective_as_revenue }, { headers });
      onChanged();
    } catch (e) { toast.error(e.response?.data?.detail || 'Could not save'); }
  };
  const saveRate = async () => {
    try {
      await axios.put(`${API_URL}/api/group-overview/collective-rate`, { rate: Number(rate) }, { headers });
      setEditRate(false); onChanged();
    } catch (e) { toast.error(e.response?.data?.detail || 'Could not save rate'); }
  };

  return (
    <div className="mt-2 rounded border border-blue-500/40 bg-blue-950/30 p-2 space-y-1.5 text-sm" data-testid="drivers-collective-block">
      <div className="flex justify-between"><span className="text-slate-300">Captured revenue</span><span className="text-white font-semibold" data-testid="transport-captured-revenue">{R(transport?.captured_revenue)}</span></div>
      <div className="flex justify-between">
        <span className="text-slate-300">Drivers' collective</span>
        <span className="text-blue-300 font-semibold" data-testid="drivers-collective-value">{R(c.value)}</span>
      </div>
      <div className="flex items-center justify-between text-xs text-slate-200">
        <span className="text-slate-200">{(c.parcels || 0).toLocaleString('en-ZA')} parcels · {c.drivers || 0} drivers ×</span>
        {editRate ? (
          <span className="flex items-center gap-1">
            R<input type="number" value={rate} onChange={(e) => setRate(e.target.value)} className="w-16 rounded bg-slate-700 px-1 text-white" data-testid="collective-rate-input" />
            <button onClick={saveRate} data-testid="collective-rate-save"><Check className="h-3.5 w-3.5 text-green-400" /></button>
            <button onClick={() => setEditRate(false)}><X className="h-3.5 w-3.5 text-slate-400" /></button>
          </span>
        ) : (
          <button className="flex items-center gap-1 hover:text-white" onClick={() => { setRate(String(c.rate_per_parcel || 0)); setEditRate(true); }} data-testid="collective-rate-edit">
            {R(c.rate_per_parcel)}/parcel <Pencil className="h-3 w-3" />
          </button>
        )}
      </div>
      {c.value > 0 && transport?.captured_revenue > 0 && Math.abs(gap) > 1 && (
        <p className={`text-xs ${gap > 0 ? 'text-amber-300' : 'text-slate-400'}`} data-testid="collective-gap">
          Gap vs captured: {R(gap)}{gap > 0 ? ' — possible uncaptured income' : ''}
        </p>
      )}
      <label className="flex items-center gap-2 text-xs text-white pt-1 cursor-pointer">
        <input type="checkbox" checked={!!transport?.use_collective_as_revenue} onChange={toggle} data-testid="use-collective-toggle" />
        Use drivers' collective as Transport revenue
      </label>
    </div>
  );
};
